import api from './client';

export const ordersApi = {
  createWithShipping: (payload) => api.post('/orders/create-with-shipping', payload),
  get: (orderId) => api.get(`/orders/${orderId}`),
};
